import MapSearch from "../MapSearch";
import MapControlButton from "./MapControlButton";

const SearchControl = () => {
  return <MapControlButton controlName="search" icon="search">
    <MapSearch />
  </MapControlButton>;
};

export default SearchControl;